import { useEffect } from 'react';
import { decodeBase64 } from '../utils/encodeBase64';
import { tokenKey, rolKey, webTokenKey } from '../utils/authHelpers';
import {
    IdHotelOwnerKey,
    usernameKey,
    sidKey,
} from '../utils/userProfileContextHelpers';

/**
 * Persists external authentication parameters and loads the destination page.
 * @param {object} options Authentication route parameters and destination URL.
 * @returns {void}
 */
const useExternalAuthEntry = ({ params, redirectTo }) => {
    const {
        token: tokenUrlParams,
        webToken: webTokenUrlParams,
        sid,
        rol,
        IdHotelOwner: IdHotelOwnerUrlParams,
        encodedUsername,
    } = params;

    useEffect(() => {
        localStorage.setItem(tokenKey, tokenUrlParams);
        localStorage.setItem(webTokenKey, webTokenUrlParams);
        localStorage.setItem(sidKey, sid);
        localStorage.setItem(rolKey, decodeBase64(rol));
        localStorage.setItem(IdHotelOwnerKey, IdHotelOwnerUrlParams);
        localStorage.setItem(usernameKey, decodeBase64(encodedUsername));
        window.location.replace(redirectTo);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useExternalAuthEntry;
